import { useDelete } from '@refinedev/core';

export const useDeleteCalendarEventMutation = () => {
  const { mutateAsync, error, isLoading } = useDelete();

  const deleteCalendarEvent = async (
    id: string,
    overrides?: Omit<Parameters<typeof mutateAsync>[0], 'id' | 'resource'>,
  ) => {
    return mutateAsync({
      ...(overrides ?? {}),
      resource: `calendar-events`,
      id,
    });
  };

  return {
    deleteCalendarEvent,
    isLoading,
    error,
  };
};
